// src/pages/ServiceVaccinePage.js
import {
  Box,
  Typography,
  Paper,
  Grid,
  Divider,
  TextField,
  Button,
  IconButton,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import QrReader from "react-qr-scanner";
import * as services from "../../services/services";
import * as dropdown from "../../services/dropdown_service";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import { useState, useEffect, useCallback } from "react";
import { transformPet } from "../../utils/reModelPet";
import { extractPetIdFromQrText } from "../../utils/qrPetId";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import IMG from "../../images/istockphoto.jpg";
import { formatDate } from "../../utils/formatDate";

const ServiceVaccinePage = () => {
  // --- state ---
  const accessToken = localStorage.getItem("accessToken");
  const navigate = useNavigate();
  const decoded = jwtDecode(accessToken);
  const [petIdInput, setPetIdInput] = useState("");
  const [pet, setPet] = useState(null);
  const [searched, setSearched] = useState(false);
  const [vaccine_dropdown, setVaccineDropdown] = useState([]);
  const [petSource, setPetSource] = useState("external");
  const [internalPetList, setInternalPetList] = useState([]);
  const [vaccineList, setVaccineList] = useState([
    {
      date: "",
      image: null,
      vaccineName: "",
      lotNo: "",
      expDate: "",
      nextDate: "",
    },
  ]);
  const [detail, setDetail] = useState([]); // ข้อมูลหมอคนเดียว
  const [vet, setVet] = useState({
    name: "",
    lastname: "",
    hospital: "",
    license_no: "",
    note: "",
  });
  const today = new Date().toISOString().split("T")[0];

  const [microchip, setMicrochip] = useState({
    date: today,
    microchip_number: "",
  });
  const [openQrDialog, setOpenQrDialog] = useState(false);

  // --- ค้นหาสัตว์เลี้ยง ---

  const searchPet = async (scannedId = null) => {
    const idToSearch = extractPetIdFromQrText(
      typeof scannedId === "string" ? scannedId : petIdInput,
    );
    if (!idToSearch) return;
    try {
      const res = await services.getPetBowById(idToSearch);
      setPet(res.data || null);
      fetchVaccine(res.data.type_id);
      if (typeof scannedId === "string") setPetIdInput(idToSearch);
    } catch (err) {
      console.error(err);
      setPet(null);
    }
    setSearched(true);
  };
  const searchInternalPet = async (keyword) => {
    try {
      const res = await services.getPetsBykeyword(keyword);
      setInternalPetList(res.data.data);
    } catch (error) {
      setInternalPetList([]);
    }
  };
  // --- โหลด dropdown วัคซีน ---
  const fetchVaccine = async (type_id) => {
    try {
      const res = await dropdown.getVaccine(type_id);
      setVaccineDropdown(res.data.results);
    } catch (err) {
      console.error(err);
    }
  };

  // --- เพิ่มรายการวัคซีน ---
  const addVaccineList = () => {
    setVaccineList([
      ...vaccineList,
      {
        date: "",
        image: null,
        vaccineName: "",
        lotNo: "",
        expDate: "",
        nextDate: "",
      },
    ]);
  };

  // --- ดึงข้อมูลหมอคนเดียว ---
  const fetchData = useCallback(async () => {
    try {
      const res = await services.getUserDetail();
      if (res.data.success) {
        setDetail(res.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // --- fill vet auto ---
  useEffect(() => {
    const doctor = detail;
    setVet({
      doctor_id: doctor.id,
      name: doctor.name,
      lastname: doctor.lastname,
      hospital: doctor?.hospital?.name,
      license_no: doctor?.license_no,
      note: "",
    });
  }, [detail]);

  const saveMicrochip = async () => {
    try {
      if (!pet) return;

      const isLinkedToBow = petSource === "external" || (petSource === "internal" && pet.petCode);

      if (isLinkedToBow) {
        let detail = `${vet.title ?? ""} ${vet.name}  ${vet.lastname}\n${vet.license_no}\n${vet.hospital}`;
        const payload = {
          id: petSource === "external" ? pet.id : pet.petCode,
          microchip_date: microchip.date,
          microchip_number: microchip.microchip_number,
          microchip_number_create: "vet",
          microchip_number_detail: detail,
        };
        const res = await services.putMicrochipRecordsBow(payload);
        if (res.status === 200) {
          const microchip_payload = {
            vetId: decoded.id,
            implantDate: new Date(microchip.date),
            microchipNumber: microchip.microchip_number,
          };

          let petData = petSource === "external"
            ? transformPet(pet, decoded.hospitalId)
            : { ...pet, hospitalId: decoded.hospitalId };

          let localPayload = {
            pet: petData,
            treatments: [
              {
                serviceType: "microchip",
                serviceDate: new Date(microchip.date),
                handledById: decoded.id,
                hospitalId: decoded.hospitalId,
                note: vet.note,
              },
            ],
            microchips: [microchip_payload],
          };
          const resTreat = await services.createTreatments(localPayload);
          if (resTreat.data.success) {
            alert("บันทึกสำเร็จ");
            navigate(`/medical_history/${resTreat.data.data.treatmentIds}`);
          }
        }
      } else {
        const microchip_payload = {
          vetId: decoded.id,
          implantDate: new Date(microchip.date),
          microchipNumber: microchip.microchip_number,
        };

        let localPayload = {
          pet: {
            ...pet,
            hospitalId: decoded.hospitalId,
          },
          treatments: [
            {
              serviceType: "microchip",
              serviceDate: new Date(microchip.date),
              handledById: decoded.id,
              hospitalId: decoded.hospitalId,
              note: vet.note,
            },
          ],
          microchips: [microchip_payload],
        };
        const resTreat = await services.createTreatments(localPayload);
        if (resTreat.data.success) {
          alert("บันทึกสำเร็จ");
          navigate(`/medical_history/${resTreat.data.data.treatmentIds}`);
        }
      }
    } catch (err) {
      console.error(err);
      alert("บันทึกไม่สำเร็จ");
    }
  };
  const calculateAgeText = (birthdate) => {
    if (!birthdate) return "-";

    const birth = new Date(birthdate);
    const today = new Date();

    let years = today.getFullYear() - birth.getFullYear();
    let months = today.getMonth() - birth.getMonth();

    if (today.getDate() < birth.getDate()) {
      months -= 1;
    }

    if (months < 0) {
      years -= 1;
      months += 12;
    }

    return `${years} ปี ${months} เดือน`;
  };
  return (
    <>
      <AppBreadcrumbs />
      <Box sx={{ p: 2 }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Typography variant="h5">บันทึกการฝังไมโครชิพ</Typography>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => {
              setPet(null);
              setSearched(false);
              setPetIdInput("");
              setVaccineList([
                {
                  date: "",
                  image: null,
                  vaccineName: "",
                  lotNo: "",
                  expDate: "",
                  nextDate: "",
                },
              ]);
            }}
          >
            เคลียร์
          </Button>
        </Box>

        {/* ค้นหาสัตว์เลี้ยง */}
        {!pet && !searched && (
          <Paper sx={{ p: 3, mb: 4 }}>
            <Typography variant="subtitle1" sx={{ mb: 2 }}>
              ค้นหาสัตว์เลี้ยง
            </Typography>
            <Box sx={{ mb: 3 }}>
              <TextField
                select
                label="แหล่งข้อมูลสัตว์เลี้ยง"
                value={petSource}
                onChange={(e) => {
                  setPetSource(e.target.value);
                  setPet(null);
                  setSearched(false);
                }}
              >
                <MenuItem value="external">จากระบบ Bow</MenuItem>
                <MenuItem value="internal">สัตว์ในโรงพยาบาล</MenuItem>
              </TextField>
            </Box>

            {petSource === "external" && (
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Pet ID หรือ สแกน QR code"
                    fullWidth
                    value={petIdInput}
                    onChange={(e) => setPetIdInput(e.target.value)}
                  />
                </Grid>
                <Grid item>
                  <IconButton color="primary" onClick={() => setOpenQrDialog(true)}>
                    <QrCodeScannerIcon fontSize="large" />
                  </IconButton>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    startIcon={<SearchIcon />}
                    onClick={searchPet}
                    size="large"
                  >
                    ค้นหา
                  </Button>
                </Grid>
              </Grid>
            )}
            {petSource === "internal" && (
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="ค้นหาสัตว์ (ชื่อ / microchip / เบอร์โทรศัพท์เจ้าของ)"
                    fullWidth
                    onChange={(e) => searchInternalPet(e.target.value)}
                  />

                  <Box sx={{ mt: 2 }}>
                    {internalPetList.map((p) => (
                      <Paper
                        key={p.id}
                        elevation={2}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          p: 1.5,
                          mb: 1,
                          cursor: "pointer",
                          transition: "0.2s",
                          "&:hover": {
                            backgroundColor: "#f5f5f5",
                            transform: "translateY(-2px)",
                          },
                        }}
                        onClick={() => {
                          setPet(p);
                          fetchVaccine(p.typeId);
                        }}
                      >
                        {/* รูป */}
                        <Box
                          component="img"
                          src={p.image ? p.image : IMG}
                          alt={p.name}
                          sx={{
                            width: 56,
                            height: 56,
                            borderRadius: 1,
                            objectFit: "cover",
                            mr: 2,
                            flexShrink: 0,
                          }}
                        />

                        {/* ข้อมูล */}
                        <Box sx={{ flex: 1 }}>
                          <Typography sx={{ fontWeight: "bold" }}>
                            {p.name}
                          </Typography>

                          <Typography variant="body2" color="text.secondary">
                            {p.hospitalPetCode || "-"} • Microchip:{" "}
                            {p.microchipNumber || "-"}
                          </Typography>

                          <Typography variant="body2">
                            เจ้าของ:{" "}
                            {p.owner
                              ? `${p.owner.firstName} ${p.owner.lastName}`
                              : "ไม่มีเจ้าของ"}
                          </Typography>
                        </Box>
                      </Paper>
                    ))}

                    {internalPetList.length === 0 && (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 2 }}
                      >
                        ไม่พบข้อมูลสัตว์เลี้ยง
                      </Typography>
                    )}
                  </Box>
                </Grid>
              </Grid>
            )}
          </Paper>
        )}

        {searched && !pet && (
          <Typography color="error" sx={{ mb: 2 }}>
            ไม่พบข้อมูลสัตว์เลี้ยง กรุณาตรวจสอบ Pet ID หรือ QR code
          </Typography>
        )}

        {/* ข้อมูลสัตว์เลี้ยง */}
        {pet && petSource === "external" && (
          <>
            <Paper sx={{ p: 2, mb: 4 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <img
                    src={pet.image ? pet.image : IMG}
                    alt={pet.name}
                    style={{
                      width: pet.image ? "70%" : "100%",
                      borderRadius: 8,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={8}>
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    ชื่อ: {pet.name}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    ข้อมูลสัตว์เลี้ยง
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        ชนิดสัตว์:
                      </Typography>{" "}
                      {pet.type}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        สายพันธุ์:
                      </Typography>{" "}
                      {pet.breed}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        เพศ:
                      </Typography>{" "}
                      {{ m: "ตัวผู้", f: "ตัวเมีย", b: "ไม่ทราบ" }[
                        pet.gender
                      ] || "-"}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        วันเกิด:
                      </Typography>{" "}
                      {formatDate(pet.birthdate)}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        อายุ:
                      </Typography>{" "}
                      {calculateAgeText(pet.birthdate)}
                      ปี
                    </Grid>
                    {/* <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        ทำหมัน:
                      </Typography>{" "}
                      {pet.sterilization_date ? "ทำแล้ว" : "ยัง"}
                    </Grid> */}
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        สีตา:
                      </Typography>{" "}
                      {pet.eye_color}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        สีขน:
                      </Typography>{" "}
                      {pet.fur_color}
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        ตำหนิ:
                      </Typography>{" "}
                      {pet.appearance_detail || "-"}
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        ไมโครชิป:
                      </Typography>{" "}
                      {pet.microchip_number || "-"}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        กรุ๊ปเลือด:
                      </Typography>{" "}
                      {pet.blood_group}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        ยาที่แพ้:
                      </Typography>{" "}
                      {pet.drug_allergies[0] || "-"}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        อาหารที่แพ้:
                      </Typography>{" "}
                      {pet.food_allergies[0] || "-"}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        โรคประจำตัว:
                      </Typography>{" "}
                      {pet.diseases[0] || "-"}
                    </Grid>
                    {/* <Grid item xs={12}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        เจ้าของ:
                      </Typography>{" "}
                      {pet.ownerName}
                    </Grid> */}
                  </Grid>
                </Grid>
              </Grid>
            </Paper>

            {/* ฟอร์มไมโครชิพ */}
            <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
              วันที่ฝังไมโครชิพ
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid xs={2} md={2}>
              <TextField
                label="วันที่ฝังไมโครชิพ"
                width="500px"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={microchip.date}
                onChange={(e) =>
                  setMicrochip((prev) => ({ ...prev, date: e.target.value }))
                }
              />
            </Grid>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, mt: 5 }}>
              เลขไมโครชิพ
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6} md={6}>
                <TextField
                  label="เลขไมโครชิพ"
                  fullWidth
                  value={microchip.microchip_number}
                  onChange={(e) =>
                    setMicrochip((prev) => ({
                      ...prev,
                      microchip_number: e.target.value,
                    }))
                  }
                />
              </Grid>
            </Grid>
            {/* ฟอร์มหมอ */}
            <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
              สัตวแพทย์
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="สัตวแพทย์ผู้ให้บริการ"
                  value={`${vet.name} ${vet.lastname}`}
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="เลขที่ใบอนุญาต"
                  value={vet.license_no}
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="ชื่อสถานพยาบาล"
                  value={vet.hospital}
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="ข้อมูลเพิ่มเติม"
                  value={vet.note}
                  onChange={(e) =>
                    setVet((prev) => ({ ...prev, note: e.target.value }))
                  }
                  multiline
                  minRows={3}
                  fullWidth
                />
              </Grid>
            </Grid>

            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                color="primary"
                sx={{ mt: 3 }}
                onClick={saveMicrochip}
              >
                บันทึกการฝังไมโครชิพ
              </Button>
            </Box>
            <Box sx={{ height: 50 }} />
          </>
        )}
        {pet && petSource === "internal" && (
          <>
            <Paper sx={{ p: 2, mb: 4 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <img
                    src={pet.image ? pet.image : IMG}
                    alt={pet.name}
                    style={{
                      width: pet.image ? "70%" : "100%",
                      borderRadius: 8,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={8}>
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    ชื่อ: {pet.name}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    ข้อมูลสัตว์เลี้ยง
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        ชนิดสัตว์:
                      </Typography>{" "}
                      {pet.type}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        สายพันธุ์:
                      </Typography>{" "}
                      {pet.breed}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        เพศ:
                      </Typography>{" "}
                      {{ m: "ตัวผู้", f: "ตัวเมีย", b: "ไม่ทราบ" }[
                        pet.gender
                      ] || "-"}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        วันเกิด:
                      </Typography>{" "}
                      {formatDate(pet.birthdate)}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        อายุ:
                      </Typography>{" "}
                      {calculateAgeText(pet.birthdate)}
                      ปี
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        ทำหมัน:
                      </Typography>{" "}
                      {pet.sterilizationDate ? "ทำแล้ว" : "ยัง"}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        สีตา:
                      </Typography>{" "}
                      {pet.eyeColor}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        สีขน:
                      </Typography>{" "}
                      {pet.furColor}
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        ตำหนิ:
                      </Typography>{" "}
                      {pet.appearanceDetail || "-"}
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        ไมโครชิป:
                      </Typography>{" "}
                      {pet.microchipNumber || "-"}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        กรุ๊ปเลือด:
                      </Typography>{" "}
                      {pet.bloodGroup}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        ยาที่แพ้:
                      </Typography>{" "}
                      {pet.drugAllergies || "-"}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        อาหารที่แพ้:
                      </Typography>{" "}
                      {pet.foodAllergies || "-"}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        โรคประจำตัว:
                      </Typography>{" "}
                      {pet.diseases[0] || "-"}
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline" }}
                      >
                        เจ้าของ:
                      </Typography>{" "}
                      {pet?.owner ? "คุณ " + pet.owner.firstName + " " + pet.owner.lastName : "ไม่มีเจ้าของ"}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>

            {/* ฟอร์มไมโครชิพ */}
            <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
              วันที่ฝังไมโครชิพ
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid xs={2} md={2}>
              <TextField
                label="วันที่ฝังไมโครชิพ"
                width="500px"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={microchip.date}
                onChange={(e) =>
                  setMicrochip((prev) => ({ ...prev, date: e.target.value }))
                }
              />
            </Grid>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, mt: 5 }}>
              เลขไมโครชิพ
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6} md={6}>
                <TextField
                  label="เลขไมโครชิพ"
                  fullWidth
                  value={microchip.microchip_number}
                  onChange={(e) =>
                    setMicrochip((prev) => ({
                      ...prev,
                      microchip_number: e.target.value,
                    }))
                  }
                />
              </Grid>
            </Grid>
            {/* ฟอร์มหมอ */}
            <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
              สัตวแพทย์
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="สัตวแพทย์ผู้ให้บริการ"
                  value={`${vet.name} ${vet.lastname}`}
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="เลขที่ใบอนุญาต"
                  value={vet.license_no}
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="ชื่อสถานพยาบาล"
                  value={vet.hospital}
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="ข้อมูลเพิ่มเติม"
                  value={vet.note}
                  onChange={(e) =>
                    setVet((prev) => ({ ...prev, note: e.target.value }))
                  }
                  multiline
                  minRows={3}
                  fullWidth
                />
              </Grid>
            </Grid>

            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                color="primary"
                sx={{ mt: 3 }}
                onClick={saveMicrochip}
              >
                บันทึกการฝังไมโครชิพ
              </Button>
            </Box>

            <Box sx={{ height: 50 }} />
          </>
        )}
        <Dialog open={openQrDialog} onClose={() => setOpenQrDialog(false)} maxWidth="sm" fullWidth>
          <DialogTitle>สแกน QR Code</DialogTitle>
          <DialogContent sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
            {openQrDialog && (
              <QrReader
                delay={300}
                resolution={640}
                qrArea={null}
                constraints={{ video: { facingMode: "environment" } }}
                onError={(err) => console.error(err)}
                onScan={(data) => {
                  if (data) {
                    const text = data.text || (typeof data === 'string' ? data : null);
                    if (text) {
                      setOpenQrDialog(false);
                      searchPet(text);
                    }
                  }
                }}
                style={{ width: '100%', maxWidth: '400px' }}
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenQrDialog(false)}>ปิด</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

export default ServiceVaccinePage;
